module.exports = __webpack_public_path__ + "img/Georgia.e49207a6.png";